<script>
import Hotkey from 'dashboard/components/base/Hotkey.vue';

const HOTKEY_LABEL_MODE = 'combined';

const isMacPlatform = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  return /Mac|iPod|iPhone|iPad/.test(window.navigator.platform || '');
};

export default {
  components: {
    Hotkey,
  },
  data() {
    return {
      keyShortcuts: [
        {
          key: 'K',
          description: this.$t('CONVERSATION.EMPTY_STATE.CMD_BAR'),
        },
        {
          key: '/',
          description: this.$t('CONVERSATION.EMPTY_STATE.KEYBOARD_SHORTCUTS'),
        },
      ],
    };
  },
  computed: {
    modifierKeyLabel() {
      if (HOTKEY_LABEL_MODE === 'combined') return 'Ctrl / ⌘';
      if (HOTKEY_LABEL_MODE === 'windows') return 'Ctrl';
      if (HOTKEY_LABEL_MODE === 'mac') return '⌘';
      return isMacPlatform() ? '⌘' : 'Ctrl';
    },
    modifierHotkeyClass() {
      const baseClass =
        'h-6 font-medium text-n-slate-12 outline outline-n-container outline-1 bg-n-alpha-3';
      return this.modifierKeyLabel.includes('/')
        ? `${baseClass} min-w-[5.5rem] px-2 text-xs`
        : `${baseClass} w-8 text-lg`;
    },
  },
};
</script>

<template>
  <div class="flex flex-col gap-2 mt-9">
    <div
      v-for="keyShortcut in keyShortcuts"
      :key="keyShortcut.key"
      class="flex items-center gap-2"
    >
      <div class="flex items-center gap-2">
        <Hotkey
          :custom-class="modifierHotkeyClass"
        >
          {{ modifierKeyLabel }}
        </Hotkey>
        <Hotkey
          custom-class="w-8 h-6 text-xs font-medium text-n-slate-12 outline outline-n-container outline-1 bg-n-alpha-3"
        >
          {{ keyShortcut.key }}
        </Hotkey>
      </div>
      <span class="text-sm font-medium text-center text-n-slate-12">
        {{ keyShortcut.description }}
      </span>
    </div>
  </div>
</template>
